import {Component,EventEmitter,Input,OnInit,Output} from '@angular/core';
import {ListView,TypeComparaison,TypeFilter} from "@domain/common/list-view";
import {Adresse,AdresseListItem} from "@domain/profil/adresse";
import {LieuParam} from "@domain/common/lieu/lieu-param";
import {LieuService} from "@components/lieu/lieu.service";
import {TranslateService} from "@ngx-translate/core";
import {AdresseService} from "@components/lieu/selection/adresse/adresse.service";
import {AdresseFiltreListItemComponent} from "@components/lieu/selection/adresse/adresses-filtre/adresse-filtre-list-item.component";

/**
 * Composant d'affichage de la page adresse avec des filtres
 *
 * @author Lionel Gimenez
 * @date 14/04/2025
 */
@Component({
    host: {'data-test-id': 'adresse-filtre'},
    selector: 'adresse-filtre',
    templateUrl: './adresse-filtre.component.html',
    providers: [AdresseService]
})
export class AdresseFiltreComponent implements OnInit {
    /** Paramétrage du lieu */
    @Input() lieuParam: LieuParam;

    /** Event émis lors de la sélection d'une adresse */
    @Output() onAdresseSelect = new EventEmitter<Adresse>();

    /** Liste des adresses du profil utilisateur */
    listeAdresseProfil: ListView<AdresseListItem,AdresseFiltreListItemComponent>;

    /**
     * Constructeur
     */
    constructor(
        private lieuService: LieuService,
        private translateService: TranslateService,
        private adresseService: AdresseService,
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        //Vérification de l'affichage dans le cas du profil (dans ce cas la liste est filtrable et affiche toutes les adresses (localisations) de l'utilisateur)
        if (this.lieuParam.isShowAdresseFiltre) {
            //Définition de la liste des adresses
            this.listeAdresseProfil = new ListView<AdresseListItem,AdresseFiltreListItemComponent>({
                uri: this.lieuParam.urlAdresse,
                title: this.translateService.instant(this.lieuParam.titleAdresseTab),
                component: AdresseFiltreListItemComponent,
                listeFilters: [{
                    clef: 'rue',
                    title: this.translateService.instant('lieu.rue'),
                    type: TypeFilter[TypeFilter.STRING],
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true
                },{
                    clef: 'ville',
                    title: this.translateService.instant('lieu.ville'),
                    type: TypeFilter[TypeFilter.STRING],
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true
                },{
                    clef: 'codePostal',
                    title: this.translateService.instant('lieu.codePostal'),
                    type: TypeFilter[TypeFilter.STRING],
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true
                },{
                    clef: 'pays',
                    title: this.translateService.instant('lieu.pays'),
                    type: TypeFilter[TypeFilter.STRING],
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true
                }],
                extraOptions: {
                    selectAdresse: (adresse) => this.selectAdresse(adresse),
                    getIconeForTypeAdresse: (typeAdresse) => this.adresseService.getIconeForTypeAdresse(typeAdresse)
                },
                listeStaticFilters: this.lieuParam.isShowAdminAndUserAdresse && this.lieuParam.idUser ? [{
                    clef: 'idUser',
                    valeur: this.lieuParam.idUser.toString(),
                    type: TypeFilter[TypeFilter.LONG],
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL]
                }] : []
            });
        }
    }

    /**
     * Selection d'une adresse dans la liste
     *
     * @param adresse
     */
    selectAdresse(adresse: Adresse): void {
        this.onAdresseSelect.emit(adresse);
    }

    /**
     * Vérifie si des informations obligatoires sont manquantes sur une adresse
     *
     * @param adresse Adresse à vérifier
     */
    isAdresseIncomplete(adresse: Adresse): boolean {
        return this.lieuService.isAdresseIncomplete(adresse);
    }
}